import React, { DetailedHTMLProps, useMemo } from 'react'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { BiInfoCircle } from 'react-icons/bi'

export const OscInput = React.forwardRef<HTMLInputElement, Props>( ( { textInfo,label, important,necessary, info, ...props }, ref ) => {

    const renderPlaceholder = useMemo(():string =>{
        if(!props.type) return ''
        switch(props.type){
            case 'email' : return 'email@email.com'
            case 'url' : return 'http://'
            default : return ''
        }
    },[props])

    return (
        <div className=''>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important &&
                        <div className='cursor-help' title={textInfo}>
                                <BiInfoCircle className='text-primary-dark ml-1' />
                        </div>}
                </div>
                {!necessary && <div className='text-sm italic '>opcional</div>}
            </label>
            <TextInput {...props} className='rounded-lg  invalid:border-pink-500 invalid:text-pink-600' placeholder={renderPlaceholder} />
            <div className='text-gray-500 text-sm'>{info}</div>
            <div>

            </div>
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    label: string,
    important?: boolean,
    necessary?:boolean
    info?:string
    textInfo?:string
}
